export const Brands = [
  {
    id: "0",
    url: "images/logos/venly-logo.svg",
    class: "w-[100px]",
  },
  {
    id: "1",
    url: "images/logos/openSea-logo.svg",
    class: "w-[130px]",
  },
  {
    id: "2",
    url: "images/logos/enjin-logo.svg",
    class: "w-[110px]",
  },
  {
    id: "3",
    url: "images/logos/wazirx-logo.svg",
    class: "w-[110px]",
  },
  {
    id: "4",
    url: "images/logos/trustWallet-logo.svg",
    class: "w-[130px]",
  },
];

export const Nfts = [
  {
    id: "0",
    url: "images/nfts/nft1.png",
    title: "Classic Jester #1672",
    profile: "images/nfts/larvartist.svg",
    artist: "@larvartist",
    price: "ETH 6",
  },
  {
    id: "1",
    url: "images/nfts/nft2.png",
    title: "Bored Ape #1789",
    profile: "images/nfts/apecreator.svg",
    artist: "@apecreator",
    price: "ETH 6",
  },
  {
    id: "2",
    url: "images/nfts/nft3.png",
    title: "Teddy Bear #1223",
    profile: "images/nfts/larvartist.svg",
    artist: "@larvartist",
    price: "ETH 2",
  },
  {
    id: "3",
    url: "images/nfts/nft4.png",
    title: "Gold Monkey #1834",
    profile: "images/nfts/apecreator.svg",
    artist: "@apecreator",
    price: "ETH 16",
  },
  {
    id: "4",
    url: "images/nfts/nft5.png",
    title: "Mr. Noir #563",
    profile: "images/nfts/hypebeast.svg",
    artist: "@hypebeast",
    price: "ETH 2.3",
  },
  {
    id: "5",
    url: "images/nfts/nft6.png",
    title: "Epic Hero #2893",
    profile: "images/nfts/nftartist.svg",
    artist: "@nftartist",
    price: "ETH 9",
  },
  {
    id: "6",
    url: "images/nfts/nft7.png",
    title: "Lion Legends #1223",
    profile: "images/nfts/hypebeast.svg",
    artist: "@hypebeast",
    price: "ETH 4.3",
  },
  {
    id: "7",
    url: "images/nfts/nft8.png",
    title: "Ayomi #1273",
    profile: "images/nfts/larvartist.svg",
    artist: "@larvartist",
    price: "ETH 2.1",
  },
  {
    id: "8",
    url: "images/nfts/nft9.png",
    title: "Big Cats #136",
    profile: "images/nfts/hypebeast.svg",
    artist: "@hypebeast",
    price: "ETH 2.1",
  },
  {
    id: "9",
    url: "images/nfts/nft10.png",
    title: "Bored Ape #1703",
    profile: "images/nfts/apecreator.svg",
    artist: "@apecreator",
    price: "ETH 2.1",
  },
  {
    id: "10",
    url: "images/nfts/nft11.png",
    title: "Classic Jester #23",
    profile: "images/nfts/larvartist.svg",
    artist: "@larvartist",
    price: "ETH 2.1",
  },
  {
    id: "11",
    url: "images/nfts/nft12.png",
    title: "Crypto Pioneer #023",
    profile: "images/nfts/nftartist.svg",
    artist: "@nftartist",
    price: "ETH 2.1",
  },
  {
    id: "12",
    url: "images/nfts/nft13.png",
    title: "Classic Jester #23",
    profile: "images/nfts/larvartist.svg",
    artist: "@larvartist",
    price: "ETH 2.1",
  },
  {
    id: "13",
    url: "images/nfts/nft14.png",
    title: "Floating in Space #136",
    profile: "images/nfts/nftartist.svg",
    artist: "@nftartist",
    price: "ETH 2.1",
  },
  {
    id: "14",
    url: "images/nfts/nft15.png",
    title: "Bored Ape #136",
    profile: "images/nfts/apecreator.svg",
    artist: "@apecreator",
    price: "ETH 2.1",
  },
  {
    id: "15",
    url: "images/nfts/nft16.png",
    title: "Big Cats #136",
    profile: "images/nfts/hypebeast.svg",
    artist: "@hypebeast",
    price: "ETH 2.1",
  },
];
